import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ChangePasswordValid } from "../validations/ChangePasswordValid";
import { useSetChangePasswordMutation } from "../../redux/user";

function ChangePasswordModal(props) {
  const [setChangePassword,{isLoading}] = useSetChangePasswordMutation();
  const [passwordfield, setPasswordfield] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordfieldErr, setPasswordfieldErr] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [disable, setdisable] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState({
    eye: "bi-eye-slash",
    type: "password",
  });
  const [showConfirmPassword, setShowConfirmPassword] = useState({
    eye: "bi-eye-slash",
    type: "password",
  });
  const [showCurrentPassword, setShowCurrentPassword] = useState({
    eye: "bi-eye-slash",
    type: "password",
  });
  const showcurrentPassword = () => {
    if (showCurrentPassword.type === "password") {
      setShowCurrentPassword({ eye: "bi-eye", type: "text" });
    } else {
      setShowCurrentPassword({ eye: "bi-eye-slash", type: "password" });
    }
  };
  const shownewPassword = () => {
    if (showNewPassword.type === "password") {
      setShowNewPassword({ eye: "bi-eye", type: "text" });
    } else {
      setShowNewPassword({ eye: "bi-eye-slash", type: "password" });
    }
  };
  const showconfirmPassword = () => {
    if (showConfirmPassword.type === "password") {
      setShowConfirmPassword({ eye: "bi-eye", type: "text" });
    } else {
      setShowConfirmPassword({ eye: "bi-eye-slash", type: "password" });
    }
  };
  const handlepassword = (e) => {
    const { name, value } = e.target;
    setPasswordfield({ ...passwordfield, [name]: value });
    let cPassword = passwordfield.confirmPassword;
    let nPassword = passwordfield.newPassword;
    let checkPassword = ChangePasswordValid(name, value, nPassword, cPassword);
    if (checkPassword?.length > 0) {
      const newErrors = { ...passwordfieldErr };
      checkPassword.forEach(({ name, error }) => {
        newErrors[name] = error;
      });

      setPasswordfieldErr(newErrors);
    } else {
      setPasswordfieldErr({
        ...passwordfieldErr,
        [checkPassword.name]: checkPassword.error,
      });
    }
  };
  const handleClose = () => {
    setPasswordfield({
      currentpassword: "",
      newpassword: "",
      confirmpassword: "",
    });
    setPasswordfieldErr({
      currentpassword: "",
      newpassword: "",
      confirmpassword: "",
    });

    props.setShow(false);
  };
  const updatePassword = async (e) => {
    e.preventDefault();
    let cPassword = passwordfield.confirmPassword;
    let nPassword = passwordfield.newPassword;
    for (let key in passwordfield) {
      let checkPassword = ChangePasswordValid(
        key,
        passwordfield[key],
        nPassword,
        cPassword
      );
      if (checkPassword?.length > 0) {
        const newErrors = { ...passwordfieldErr };
        checkPassword.forEach(({ name, error }) => {
          newErrors[name] = error;
        });

        setPasswordfieldErr(newErrors);
        if (checkPassword[0].error !== "" || checkPassword[1].error !== "") {
          return false;
        }
      } else {
        setPasswordfieldErr({
          ...passwordfieldErr,
          [checkPassword.name]: checkPassword.error,
        });
        if (checkPassword.error !== "") {
          return false;
        }
      }
    }
    const data = {
      oldPassword: passwordfield.currentPassword,
      newPassword: passwordfield.newPassword,
      confirmPassword: passwordfield.confirmPassword,
    };
    setdisable(true);
    setChangePassword(data)
      .then((result) => {
        if (result.error) {
          toast.dismiss();
          toast.error(result.error.data.message);
          setdisable(false);
          return;
        }
        if (result.data.status) {
          toast.dismiss();
          toast.success(result.data.message);
          setTimeout(() => {
            setdisable(false);
            handleClose();
            props.logout();
            window.location.href = "/";
          }, 2000);
        } else {
          setdisable(false);
          toast.dismiss();
          toast.error(result.data.message);
        }
      })
      .catch((error) => {
        setdisable(false);
        toast.dismiss();
        toast.error(error.message);
      });
  };
  return (
    <>
      <Modal show={props.show} className="change_p_p">
        <Modal.Header>
          <Modal.Title>Change Password </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label> Current Password </Form.Label>
              <div className="password-group">
                <Form.Control
                  type={showCurrentPassword.type}
                  name="currentPassword"
                  value={passwordfield.currentPassword}
                  placeholder="Enter Current Password"
                  onChange={handlepassword}
                  className="password"
                  maxLength={16}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  onCopy={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  onInput={(event) => {
                    // Remove spaces if user uses mobile/touch input
                    event.target.value = event.target.value.replace(/\s/g, "");
                  }}
                />
                <span
                  role="button"
                  onClick={showcurrentPassword}
                  className="eye-icon"
                >
                  <i className={`bi ${showCurrentPassword.eye}`}></i>
                </span>
              </div>

              <span style={{ color: "red" }}>
                {passwordfieldErr.currentPassword}
              </span>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label> New Password</Form.Label>
              <div className="password-group">
                <Form.Control
                  type={showNewPassword.type}
                  name="newPassword"
                  placeholder="Enter New Password"
                  value={passwordfield.newPassword}
                  onChange={handlepassword}
                  className="password"
                  maxLength={16}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  onCopy={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  onInput={(event) => {
                    // Remove spaces if user uses mobile/touch input
                    event.target.value = event.target.value.replace(/\s/g, "");
                  }}
                />
                <span
                  role="button"
                  onClick={shownewPassword}
                  className="eye-icon"
                >
                  <i className={`bi ${showNewPassword.eye}`}></i>
                </span>
              </div>
              <span style={{ color: "red" }}>
                {passwordfieldErr.newPassword}
              </span>
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label> Confirm Password</Form.Label>
              <div className="password-group">
                <Form.Control
                  type={showConfirmPassword.type}
                  name="confirmPassword"
                  placeholder=" Enter Confirm Password"
                  value={passwordfield.confirmPassword}
                  rows={3}
                  onChange={handlepassword}
                  className="password"
                  maxLength={16}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  onCopy={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  onInput={(event) => {
                    // Remove spaces if user uses mobile/touch input
                    event.target.value = event.target.value.replace(/\s/g, "");
                  }}
                />
                <span
                  role="button"
                  onClick={showconfirmPassword}
                  className="eye-icon"
                >
                  <i className={`bi ${showConfirmPassword.eye}`}></i>
                </span>
              </div>
              <span style={{ color: "red" }}>
                {passwordfieldErr.confirmPassword}
              </span>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={(e) => {
              updatePassword(e);
            }}
            type="submit"
            disabled={disable}
          >
            {isLoading?"Loading...":"Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ChangePasswordModal;
